import {defaultCategories} from '../data/defaultData.js';
import {DEVICE_ONLY_SETTINGS} from './workspaceSchema.js';

// A first-time browser is pre-populated with default categories; this alone
// is not customer financial data. Refuse all automatic restore if ANY other
// local records, custom categories or customer-specific settings are present.
export function isPristineCustomerWorkspace(backup){
 const data=backup?.data;
 if(!data||!Array.isArray(data.categories)||!Array.isArray(data.settings))return false;
 for(const key of ['transactions','budgets','people','ious','recurringRules']){
  if(!Array.isArray(data[key])||data[key].length)return false;
 }
 if(data.categories.length!==defaultCategories.length)return false;
 const expected=new Map(defaultCategories.map(c=>[c.type+':'+c.name,c]));
 const seen=new Set();
 for(const category of data.categories){
  const key=category?.type+':'+category?.name,def=expected.get(key);
  if(!def||seen.has(key))return false;
  seen.add(key);
  if(Object.keys(def).some(k=>category[k]!==def[k]))return false;
  if(Object.keys(category).some(k=>!Object.hasOwn(def,k)&&!['id','createdAt','updatedAt'].includes(k)))return false;
 }
 return data.settings.every(entry=>
  entry&&typeof entry.key==='string'&&
  (DEVICE_ONLY_SETTINGS.includes(entry.key)||
   (entry.key==='categorizationRules'&&Array.isArray(entry.value)&&entry.value.length===0)));
}

// Web Locks serialise finance writes and automatic imports across same-origin
// tabs. On older browsers normal edits still work, but automatic replacement
// fails closed rather than relying on a non-atomic localStorage mutex.
export function withWorkspaceWriteLock(userId,work,{required=false}={}){
 const locks=typeof navigator!=='undefined'?navigator.locks:null;
 if(!userId||!locks?.request){
  if(required)throw new Error('This browser cannot safely coordinate financial restores across tabs. Update your browser or open Expense Manager in a supported browser before retrying. Your local financial records are unchanged.');
  return Promise.resolve().then(work);
 }
 return locks.request('bpa-expense-workspace-write:'+userId,{mode:'exclusive'},work);
}

// This is an offline-safe "needs backup" marker, NOT financial data.
// Scoped to an authenticated BPA user and stored in same-origin localStorage.
const PREFIX='bpa-expense-google-dirty-v1:';
export const localDirtyMarker=userId=>{
 if(!userId||typeof localStorage==='undefined')return '';
 try{return localStorage.getItem(PREFIX+userId)||''}catch{return ''}
};
export function markLocalDirty(userId){
 if(!userId||typeof window==='undefined')return;
 const marker=Date.now().toString(36)+'-'+(typeof crypto!=='undefined'&&crypto.randomUUID
   ?crypto.randomUUID():Math.random().toString(36).slice(2));
 try{localStorage.setItem(PREFIX+userId,marker)}catch(e){
   console.warn('Could not persist Google backup pending marker',e);
 }
 window.dispatchEvent(new CustomEvent('bpa:finance-mutated',{detail:{userId}}));
}
export function acknowledgeLocalDirty(userId,expectedMarker){
 if(!userId||typeof localStorage==='undefined')return false;
 try{
   if(localDirtyMarker(userId)!==expectedMarker)return false;
   localStorage.removeItem(PREFIX+userId);
   return true;
 }catch{return false}
}
export function signalGoogleReady(){
 if(typeof window!=='undefined')window.dispatchEvent(new Event('bpa:google-ready'));
}